import ActionTypes from './types';
import { convertSecTimeStampToMiliSec, getCentroidFromGeoJson } from './../utils/';

const getProcessedLocationsLayer = (layer) => {
  const pointsOfInterestFeatures = [];
  const parkingLocationFeatures = [];
  layer.geojson.features.forEach(feature => {
    const { ltype, location, spotid, minvehicle } = feature.properties;

    feature.centerCoordinates = getCentroidFromGeoJson(feature.geometry.coordinates[0]);
    // adding coordinates to location layer
    if (ltype === 'poi') {
      pointsOfInterestFeatures.push(feature);
    } else {
      parkingLocationFeatures.push(feature);
    }
  });

  const pointsOfInterestGeojson = {
    ...layer.geojson,
    features: pointsOfInterestFeatures
  };

  const pointsOfInterestLayer = {
    ...layer,
    geojson: pointsOfInterestGeojson,
    label: "PointsOfInterest"
  };

  const parkingLocationsGeojson = {
    ...layer.geojson,
    features: parkingLocationFeatures
  };

  const parkingLocationsLayer = {
    ...layer,
    geojson: parkingLocationsGeojson,
    label: "ParkingAreaMarker"
  };

  // If we want to split parkingLocations & pointOfInterests
  // Would also need to convert from a GeoJson to a <div> with attached label inside
  // return { parkingLocationsLayer, pointsOfInterestLayer };
  return { parkingLocationsLayer: layer, pointsOfInterestLayer };
};

const getProcessedLayer = (layer) => {
  const parkingSpotFeatures = [];
  const pointsOfInterestFeatures = [];
  const areaSpotsHash = {};
  const blockedSpots = [];
  const preBookedSpots = [];
  const parkingSpotFeaturesList = {};
  layer.geojson.features.forEach(feature => {
    const { ltype, location, spotid, minvehicle } = feature.properties;

    feature.centerCoordinates = getCentroidFromGeoJson(feature.geometry.coordinates[0]);
    if (!areaSpotsHash.hasOwnProperty(location)) {
        areaSpotsHash[location] = [];
    }
    if (!minvehicle) {
      blockedSpots.push(spotid);
    } else if (minvehicle > 1) {
      preBookedSpots.push(spotid);
    }
    areaSpotsHash[location].push(spotid);
    parkingSpotFeaturesList[spotid] = feature;
    parkingSpotFeatures.push(feature);
  });

  const parkingSpotsGeojson = {
    ...layer.geojson,
    features: parkingSpotFeatures
  };

  const pointsOfInterestGeojson = {
    ...layer.geojson,
    features: pointsOfInterestFeatures
  };

  const parkingSpotsLayer = {
    ...layer,
    geojson: parkingSpotsGeojson
  };

  const pointsOfInterestLayer = {
    ...layer,
    geojson: pointsOfInterestGeojson,
    label: "PointsOfInterest"
  };

  return {
    areaSpotsHash,
    blockedSpots,
    parkingSpotsLayer,
    parkingSpotFeaturesList,
    pointsOfInterestLayer,
    preBookedSpots
  };

};

const getAreaSpotsMapList = (areaSpotsMap) => {
  return areaSpotsMap.reduce((acc, list) => {
    for (let k in list){
      if (acc.hasOwnProperty(k)){
        acc[k] = [...acc[k], ...list[k]];
      } else {
        acc[k] = [...list[k]];
      }
    }
    return acc;
  }, {});
};

export const getProcessedGeoJson = (mapGeoJson) => {
  const areaSpotsMap = [];
  const processedGeoJson = {
    parkingLocations: [],
    parkingSpots: [],
    pointsOfInterest: [],
    blockedSpotsList: [],
    preBookedSpotsList: []
  };
  let parkingSpotFeaturesListMap = [];

  mapGeoJson.forEach(layer => {
    const { label } = layer;
    if (label === 'overview') {
      const { parkingLocationsLayer, pointsOfInterestLayer } = getProcessedLocationsLayer(layer);

      pointsOfInterestLayer.maxzoom = 99; // @todo temp override

      processedGeoJson.pointsOfInterest.push(pointsOfInterestLayer);
      processedGeoJson.parkingLocations.push(parkingLocationsLayer);
    } else if(label === 'parking') {
      const processedLayer = getProcessedLayer(layer);
      processedGeoJson.parkingSpots.push(processedLayer.parkingSpotsLayer);
      // processedGeoJson.pointsOfInterest.push(processedLayer.pointsOfInterestLayer);

      areaSpotsMap.push(processedLayer.areaSpotsHash);
      processedGeoJson.blockedSpotsList.push(...processedLayer.blockedSpots);
      processedGeoJson.preBookedSpotsList.push(...processedLayer.preBookedSpots);
      parkingSpotFeaturesListMap.push(processedLayer.parkingSpotFeaturesList);
    }
  });

  processedGeoJson.areaSpotsMapList = getAreaSpotsMapList(areaSpotsMap);
  processedGeoJson.parkingSpotFeaturesList =  parkingSpotFeaturesListMap.reduce((acc, item) => {
    return { ...acc, ...item };
  }, {});

  return processedGeoJson;
};

export const setGeoJson = (mapGeoJson) => {
  return (dispatch) => {
    if (!Object.keys(mapGeoJson).length) {
      console.error('Geo JSON data not found');
      return false;
    }

    const processedGeoJson = getProcessedGeoJson(mapGeoJson);

    dispatch({
      type: ActionTypes.SET_AREA_SPOTS_MAPPING_LIST,
      areaSpotsMapList: processedGeoJson.areaSpotsMapList
    });

    dispatch({
      type: ActionTypes.SET_PARKING_SPOT_FEATURES_LIST,
      parkingSpotFeaturesList: processedGeoJson.parkingSpotFeaturesList
    });

    dispatch({
      type: ActionTypes.UPDATE_BLOCKED_SPOTS_LIST,
      blockedSpotsList: processedGeoJson.blockedSpotsList
    });

    dispatch({
      type: ActionTypes.UPDATE_PREBOOKED_SPOTS_LIST,
      preBookedSpotsList: processedGeoJson.preBookedSpotsList
    });

    dispatch({
      type: ActionTypes.SET_GEOJSON,
      parkingLocations: processedGeoJson.parkingLocations,
      parkingSpots: processedGeoJson.parkingSpots,
      pointsOfInterest: processedGeoJson.pointsOfInterest,
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/geoJson.js